import DropzoneRequestsProvider from './DropzoneRequests.provider';

export default DropzoneRequestsProvider;